import { render, staticRenderFns } from "./modalPenalty.vue?vue&type=template&id=110e97dc&"
import script from "./modalPenalty.vue?vue&type=script&lang=js&"
export * from "./modalPenalty.vue?vue&type=script&lang=js&"
import style0 from "./modalPenalty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports